var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationRepostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 162,
    viewBox: "0 0 196 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.059 18.9664C128.105 22.8966 140.604 29.3399 149.163 39.4429C157.416 49.1833 157.53 62.0071 161.465 73.743C166.036 87.3724 180.581 101.452 174.161 113.985C167.652 126.691 147.504 125.68 132.876 129.554C122.242 132.371 111.574 132.643 100.473 133.502C88.2474 134.449 76.0164 139.077 64.3799 134.86C51.8742 130.327 39.3413 121.669 35.1586 109.83C31.0273 98.137 42.6377 87.3474 43.3143 75.2353C44.0426 62.1985 33.1125 48.3515 39.2378 36.8106C45.4358 25.1328 60.6213 20.1016 74.2831 16.8864C87.5897 13.7547 101.706 14.9443 115.059 18.9664Z",
    fill: "#F4F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0005 87.0585C20.335 87.6777 17.5005 87.7596 14.9621 86.7298C12.5149 85.7369 11.1494 83.3015 9.23815 81.4748C7.01853 79.3533 3.02918 78.1927 2.82261 75.1272C2.61318 72.0191 6.19877 70.0977 8.31826 67.8231C9.85904 66.1696 11.6726 64.9983 13.4994 63.6693C15.5113 62.2055 17.1378 60.0388 19.5899 59.6225C22.2252 59.1751 25.2981 59.5123 27.2628 61.3327C29.2033 63.1307 28.3306 66.4083 29.4848 68.7908C30.7272 71.3553 34.0679 72.8509 34.2212 75.6962C34.3764 78.5753 32.282 81.1291 30.2602 83.1764C28.291 85.1705 25.7284 86.4249 23.0005 87.0585Z",
    fill: "#F4F8FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4286 87.0131V76.8927H94.7666V73.0395H92.8072V69.8031H92.1196V64.2549H91.9421V69.8031H91.2545V73.0395H89.2952V76.8927H85.6612V87.0131H84.9057V105.387H79.2711V126.333H84.9057H90.5404H99.156V87.0131H98.4286Z",
    fill: "#B9CFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.147 73.0391H136.421V73.5568H137.223V121.718H153.345V73.5568H154.147V73.0391Z",
    fill: "#DDE8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.795 121.594H58.6732V137.916H167.795V121.594Z",
    fill: "#DDE8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.713 106.389H58.8594V137.989H75.713V106.389Z",
    fill: "#DDE8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4998 82.1621H59.913V137.99H71.4998V82.1621Z",
    fill: "#DDE8FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6543 102.175H33.1208V137.989H43.6543V102.175Z",
    fill: "#B9CFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2806 133.775H14.1603V137.989H36.2806V133.775Z",
    fill: "#8DB1FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2011 133.775H53.1342V137.989H74.2011V133.775Z",
    fill: "#B9CFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2271 123.242H27.0837L23.6403 135.882H35.2271V123.242Z",
    fill: "#8DB1FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2405 125.349H41.547V137.989H55.2405V125.349Z",
    fill: "#B9CFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5607 112.709H52.0806V135.883H61.5607V112.709Z",
    fill: "#B9CFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.941 133.775H156.82V137.989H178.941V133.775Z",
    fill: "#B9CFFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M173.674 125.349H159.981V137.989H173.674V125.349Z",
    fill: "#B9CFFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M164.194 114.815H154.714V137.989H164.194V114.815Z",
    fill: "#B9CFFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.74 133.775H93.6193V137.989H115.74V133.775Z",
    fill: "#8DB1FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.473 125.349H96.7795V137.989H110.473V125.349Z",
    fill: "#8DB1FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3748 129.562H81.5746V137.989H97.3748V129.562Z",
    fill: "#9CD2FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M130.531 111.14H109.951V137.989H130.531V111.14Z",
    fill: "#B9CFFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M131.732 110.11H109.419V111.14H131.732V110.11Z",
    fill: "#B9CFFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M129.619 107.314H120.575V112.758H129.619V107.314Z",
    fill: "#B9CFFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M117.621 107.314H116.102V110.625H117.621V107.314Z",
    fill: "#B9CFFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M114.584 107.314H112.913V110.625H114.584V107.314Z",
    fill: "#B9CFFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M148.754 132.667H131.54V138.049H148.754V132.667Z",
    fill: "#8DB1FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M137.817 120.082H133.184V133.289H139.791L137.817 120.082Z",
    fill: "#8DB1FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.016 49.7265C187.62 38.5592 183.952 28.3646 177.13 20.8203C170.308 13.2764 160.531 8.60296 149.361 8.08496",
    stroke: "#307F92",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M167.188 49.1001C167.436 43.6708 165.474 37.9596 162.168 34.3043L162.001 34.1199C158.696 30.4637 153.21 27.9387 147.783 27.6406",
    stroke: "#307F92",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0787 111.211L90.4648 109.96L74.9364 132.92H92.2663L93.9363 131.831V111.997L93.0787 111.211Z",
    fill: "#407093"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7009 110.073L84.8239 107.26H83.7163L67.0983 131.831L68.0876 132.92H75.2491L90.7009 110.073Z",
    fill: "#365E7D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0562 131.831H74.1408C73.0998 131.831 72.2559 132.675 72.2559 133.716V136.105C72.2559 137.145 73.0996 137.989 74.1405 137.989H97.0562C98.0972 137.989 98.9412 137.146 98.9412 136.105V133.716C98.9412 132.675 98.0972 131.831 97.0562 131.831Z",
    fill: "#4A80AA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6458 136.105V133.716C72.6458 132.675 73.4898 131.831 74.5308 131.831H62.3927C61.3517 131.831 60.5077 132.675 60.5077 133.716V136.105C60.5077 137.146 61.3517 137.989 62.3927 137.989H74.5306C73.4896 137.989 72.6458 137.146 72.6458 136.105Z",
    fill: "#407093"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.912 96.4336C89.2066 97.8887 88.808 99.5203 88.808 101.246C88.808 105.963 91.7614 109.986 95.9182 111.578C97.7029 111.019 99.2886 110.01 100.541 108.682V106.272L89.912 96.4336Z",
    fill: "#4A80AA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9944 101.284C88.9944 99.598 89.3843 98.0043 90.0745 96.5834L86.6769 93.4385H85.2982C83.2134 95.4052 81.91 98.1915 81.91 101.284C81.91 107.241 86.7392 112.07 92.6964 112.07C93.9372 112.07 95.1272 111.857 96.2363 111.471C92.0208 110.005 88.9944 105.999 88.9944 101.284Z",
    fill: "#407093"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M151.619 42.3612C149.912 40.6543 147.145 40.6543 145.438 42.3612L141.267 46.5322V47.0609L146.473 52.4879L147.448 52.7131L151.619 48.5421C153.326 46.8354 153.326 44.0681 151.619 42.3612Z",
    fill: "#FFD086"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M152.772 44.4243C152.59 43.6687 152.209 42.9512 151.619 42.3612C149.912 40.6543 147.145 40.6543 145.438 42.3612L141.267 46.5322V47.0609L144.027 49.9382C145.673 48.2258 147.307 46.536 148.147 45.6958C149.547 44.2954 151.593 44.2846 152.772 44.4243Z",
    fill: "#FFC365"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M137.338 53.4721C137.29 53.4721 137.242 53.4697 137.193 53.465L88.993 48.7206C88.1892 48.6415 87.6019 47.9259 87.681 47.122C87.7601 46.3182 88.4761 45.7312 89.2796 45.8098L137.48 50.5539C138.283 50.633 138.871 51.3487 138.792 52.1525C138.717 52.9079 138.081 53.4721 137.338 53.4721Z",
    fill: "#365E7D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M102.933 62.4951C102.284 62.4951 101.692 62.0602 101.519 61.4034C101.314 60.6221 101.782 59.8226 102.563 59.6176L136.965 50.594C137.747 50.3894 138.546 50.8563 138.751 51.6377C138.956 52.4188 138.489 53.2183 137.708 53.4233L103.305 62.4469C103.18 62.4794 103.056 62.4951 102.933 62.4951Z",
    fill: "#407093"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M146.682 106.336C145.939 106.336 145.302 105.771 145.228 105.016L140.514 56.786C140.435 55.9823 141.023 55.2669 141.827 55.1881C142.631 55.1132 143.346 55.6976 143.424 56.5015L148.139 104.731C148.218 105.535 147.63 106.25 146.826 106.329C146.778 106.333 146.73 106.336 146.682 106.336Z",
    fill: "#365E7D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M132.809 92.6475C132.685 92.6475 132.559 92.6314 132.433 92.5983C131.653 92.3912 131.188 91.5906 131.395 90.8099L140.551 56.2744C140.758 55.4935 141.558 55.0292 142.339 55.2355C143.12 55.4426 143.585 56.2432 143.378 57.0239L134.222 91.5594C134.048 92.2147 133.456 92.6475 132.809 92.6475Z",
    fill: "#407093"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M137.075 50.7227L141.256 46.541L147.437 52.7211L143.255 56.9027L137.075 50.7227Z",
    fill: "#FFC365"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.25 53.881C141.255 52.8286 142.825 51.1872 144.343 49.6091L141.266 46.5322L137.084 50.7144L140.25 53.881Z",
    fill: "#FFA90F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M144.196 59.2888C143.821 59.2888 143.447 59.1458 143.162 58.8604L135.119 50.8178C134.548 50.2466 134.548 49.3208 135.119 48.7494C135.69 48.1786 136.616 48.1786 137.187 48.7494L145.23 56.792C145.801 57.3633 145.801 58.289 145.23 58.8604C144.944 59.146 144.57 59.2888 144.196 59.2888Z",
    fill: "#4A80AA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M145.14 108.969L96.1729 59.5771C89.6808 74.2334 88.5535 89.9667 93.4137 103.534C106.836 115.642 126.887 117.501 145.346 109.89L145.14 108.969Z",
    fill: "#B5DCFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4339 59.8399L85.2147 48.5234L84.0904 48.6344C76.1859 67.8046 78.4939 88.6934 91.8903 102.09C92.7018 102.901 93.5414 103.671 94.4058 104.402C88.7586 90.8503 89.6764 74.7329 96.4339 59.8399Z",
    fill: "#8BCAFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M149.615 105.458L99.9518 55.7949C99.4631 55.8703 98.9926 56.0925 98.6163 56.4687L96.4561 58.6291C95.9922 59.093 95.7615 59.6989 95.7549 60.307L145.261 109.813C145.997 110.549 147.19 110.549 147.926 109.813L149.616 108.124C150.351 107.388 150.351 106.195 149.615 105.458Z",
    fill: "#DBEDFF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5305 58.6657L98.6457 56.5506C99.0352 56.161 99.5271 55.9381 100.035 55.8777L88.5216 44.3646C87.7855 43.6285 86.5922 43.6285 85.8559 44.3646L84.1668 46.0536C83.4307 46.7897 83.4307 47.9831 84.1668 48.7192L95.8418 60.3941C95.8264 59.7703 96.0545 59.1417 96.5305 58.6657Z",
    fill: "#B5DCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationRepostIcon);
export default __webpack_public_path__ + "static/media/confirmation-repost-icon.22f2c09f143a56e30f706a84459fd394.svg";
export { ForwardRef as ReactComponent };